import type { paths } from "@/api-schema";
import { alphartisApiAxios } from "@/config/axios";
import { useMutation, useQueryClient } from "@tanstack/react-query";

export const COMPANY_RESTORE_RESOURCE = "company" as const;
export const COMPANY_RESTORE_API_PATH = `/v1/${COMPANY_RESTORE_RESOURCE}/{uuid}/restore` as const;

export type CompanyRestoreResponse =
  paths[typeof COMPANY_RESTORE_API_PATH]["patch"]["responses"][200]["content"]["application/json"];

export const useCompanyRestoreMutation = () => {
  const queryClient = useQueryClient();

  return useMutation<CompanyRestoreResponse, Error, { uuid: string }>({
    mutationFn: async ({ uuid }) => {
      const response = await alphartisApiAxios.patch<CompanyRestoreResponse>(
        `/v1/${COMPANY_RESTORE_RESOURCE}/${uuid}/restore`,
      );
      return response.data;
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: [COMPANY_RESTORE_RESOURCE],
      });
    },
  });
};
